import { Star } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';

const testimonials = [
  {
    quote: "Les coupons sont super clairs, pas besoin d'etre un expert pour comprendre. Je suis les pronostiqueurs en haut du classement surtout sur le football et ca fonctionne !",
    name: 'Yves Carro',
    meta: 'Membre depuis 1 mois',
    initials: 'YC',
    color: '#F5A623',
    stars: 5,
  },
  {
    quote: "L'application est vraiment intuitive et rapide. J'adore pouvoir voir directement qui sont les meilleurs pronostiqueurs du moment. Les coupons sont simples a suivre.",
    name: 'Sophie Dubois',
    meta: 'Membre depuis 2 semaines',
    initials: 'SD',
    color: '#4ECDC4',
    stars: 5,
  },
  {
    quote: "Enfin une plateforme qui met vraiment en avant le talent ! Les resultats parlent d'eux-memes. C'est ce genre de details qui fait la difference.",
    name: 'Rachid Lahmidi',
    meta: 'Membre depuis 1 semaine',
    initials: 'RL',
    color: '#A78BFA',
    stars: 5,
  },
  {
    quote: "Je publie mes coupons sur TIGOO et le systeme de classement me motive a etre encore meilleur. La communaute est super et les retours sont encourageants.",
    name: 'Mamadou Diallo',
    meta: 'Pronostiqueur · Top 10',
    initials: 'MD',
    color: '#F87171',
    stars: 5,
  },
  {
    quote: "Ce qui me plait c'est la transparence. Les stats ne mentent pas, on voit vraiment qui performe. Plus de blabla, que des resultats.",
    name: 'Thomas Martin',
    meta: 'Membre depuis 3 semaines',
    initials: 'TM',
    color: '#60A5FA',
    stars: 5,
  },
  {
    quote: "J'ai teste beaucoup de plateformes mais TIGOO est la seule qui verifie vraiment les resultats. Ca change tout pour la confiance.",
    name: 'Aminata Kone',
    meta: 'Membre depuis 2 mois',
    initials: 'AK',
    color: '#34D399',
    stars: 5,
  },
];

function Stars({ count }) {
  return (
    <div className="testi-stars">
      {Array.from({ length: count }, (_, i) => (
        <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
      ))}
    </div>
  );
}

function TestiCard({ t, index }) {
  const [ref, isVisible] = useScrollReveal();
  return (
    <div
      className={`testi-card ${isVisible ? 'visible' : ''}`}
      ref={ref}
      style={{ animationDelay: `${index * 0.12}s` }}
    >
      <Stars count={t.stars} />
      <span className="quote-mark">"</span>
      <blockquote>{t.quote}</blockquote>
      <div className="testi-author">
        <div className="author-avatar" style={{ background: t.color }}>{t.initials}</div>
        <div>
          <span className="author-name">{t.name}</span>
          <span className="author-meta">{t.meta}</span>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="testimonials">
      <div className={`testimonials-header reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <span className="section-label">Témoignages</span>
        <h2 className="section-title">Ce que disent nos membres</h2>
        <p className="section-sub">Découvrez l'experience de notre communauté grandissante.</p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((t, i) => (
          <TestiCard key={i} t={t} index={i} />
        ))}
      </div>
    </section>
  );
}
